import styled from 'styled-components';

export const DotsComponent = styled.div<{ open: boolean }>`
  height: 24px;
  width: 30px;
  position: relative;
  opacity: 1;
  text-align: center;

  &:hover {
    cursor: pointer;
    opacity: ${(props) => (props.open ? '1.0' : '0.8')};
  }
`;

export const SettingContainer = styled.div<{ open: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.open ? '150px' : '0')};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${(props) =>
    props.open ? props.theme.shadows[6] : props.theme.shadows[0]};
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 10px;
  transition: width 0.1s ease-in;
`;

export const IndividualSetting = styled.div<{ enabled: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  padding-left: 2px;
  font-size: 14px;

  transition: max-height 0.2s;
  border-bottom: 1px solid ${({ theme }) => theme.palette.background.default}88;
  min-height: 40px;
  user-select: none;

  ${(props) =>
    props.enabled
      ? `color: ${props.theme.palette.text.primary};`
      : `color: ${props.theme.palette.text.disabled};`}

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    ${(props) =>
      props.enabled
        ? `color: ${props.theme.palette.text.primary}; background-color: ${props.theme.palette.grey.A200};`
        : `color: ${props.theme.palette.text.disabled};`}
  }
`;
